import Swal from "sweetalert2";

const swaltoast = Swal.mixin({
  toast: true,
  animation: true,
  showConfirmButton: false,
  position: "top-end",
  timer: 5000,
});

const loadingToastMixin = Swal.mixin({
  toast: true,
  html: `
    <div class="flex flex-row items-center gap-4 p-2">
        <span class="loading loading-spinner loading-lg text-primary"></span>
        Estamos procesando su solicitud.
    </div>
    `,
  showConfirmButton: false,
  position: "top-end",
});

export const loadingToast = () => {
  loadingToastMixin.fire();
};
export const closeToast = () => Swal.close();

const defaultMsg = {
  error: "¡Oops, tuvimos un error!",
  success: "Operacion realizada exitosamente",
};

export const toast = (icon, title = null, position = 'top-right') => {
  swaltoast.fire({
    icon: icon,
    title: title || defaultMsg[icon],
    position: position
  });
};

export default { toast, loadingToast, closeToast };
